// extracted by mini-css-extract-plugin
module.exports = {"XStream":"XStream_XStream__Xro9m"};